// extracted by mini-css-extract-plugin
export var component = "svg-module--component--1Czqy";
export var light = "svg-module--light--3e6li";
export var appStore = "svg-module--app-store--2H6in";
export var ps4 = "svg-module--ps4--18qV5";
export var steam = "svg-module--steam--1cS2G";
export var xboxOne = "svg-module--xboxOne--8ptoe";